import { environment } from "./environments/environment";

export class GrowthBookService {
  private _gb: any;

  constructor() {
    this.initialize();
  }

  private initialize() {
    if (typeof window !== 'undefined' && window["growthbook"]) {
      this._gb = new window["growthbook"].GrowthBook({
        apiHost: environment.growthbookHostApi,
        clientKey: environment.growthbookClientKey,
        enableDevMode: true,
        subscribeToChanges: true,
        trackingCallback: (experiment, result) => {
          console.log("Viewed Experiment", {
            experimentId: experiment.key,
            variationId: result.key,
          });
        },
      });
      this._gb.loadFeatures();
    } else {
      // Fallback for testing or when growthbook is not available
      this._gb = {
        setAttributes: () => {},
        isOn: () => false,
        loadFeatures: () => {}
      };
    }
  }

  setAttributes(attributes: any): void {
    if (this._gb && this._gb.setAttributes) {
      this._gb.setAttributes(attributes);
    }
  }

  public isOn(feature: string): boolean {
    if (!this._gb) {
      console.warn('GrowthBook not initialized, feature flag check failed:', feature);
      return false;
    }
    return this._gb.isOn(feature);
  }

  public loadFeatures(): void {
    if (!this._gb) {
      console.warn('GrowthBook not initialized, cannot load features');
      return;
    }
    this._gb.loadFeatures();
  }

  public getFeatureValue(feature: string, fallback?: any): any {
    if (!this._gb) {
      console.warn('GrowthBook not initialized, returning fallback for feature:', feature);
      return fallback;
    }
    return this._gb.getFeatureValue ? this._gb.getFeatureValue(feature, fallback) : fallback;
  }

  public setRenderer(callback: () => void): void {
    if (!this._gb) {
      console.warn('GrowthBook not initialized, cannot set renderer');
      return;
    }
    if (this._gb.setRenderer) {
      this._gb.setRenderer(callback);
    }
  }
}

// Export a singleton instance
export const gb = new GrowthBookService();


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/growthbook.ts